import React, { useState, useEffect, useMemo, useRef } from "react";
import { Modal, Button, ListGroup, ToggleButtonGroup, ToggleButton, Spinner } from "react-bootstrap";
import { NotificationManager } from "react-notifications";
import useFetch from "../../hooks/fetchMSSQL-hook";
import DateRangePicker from "../DateRangePicker/DateRangePicker";
import moment from "moment";


export default function ReportForm({
  show,
  onHide,
  onConfirm,
  reportConditionId,
  reportConditionName,
  reportId,
  reportList = [],
  loadingEdit,
  setLoadingEdit,
  loadingScheduler,
  setLoadingScheduler,
  reportTask
}) {
    const [step, setStep] = useState("select");
    const [selectedReport, setSelectedReport] = useState({});
    const [range, setRange] = useState({ start: moment().subtract(1, "day").format("YYYY-MM-DDTHH:mm"), end: moment().format("YYYY-MM-DDTHH:mm")});
    const min = moment().add(3600, "seconds").format("YYYY-MM-DDTHH:mm");
    const [typedReport, setTypedReport] = useState({ name: "", id: "", description: ""})
    const [inputs, setInputs] = useState({});
    const [users, setUsers] = useState([]);
    const [filter, setFilter] = useState({
        reportName: "",
        isShared: 1,
        timeSpan: 0,
        machines: { id: [], name: []},
        MachinesTags: { id: [], name: [], type: []},
        allMachines: 1,
        products: { id: [], name: []},
        ProductsTags: { id: [], name: [], type: []},
        allProducts: 1,
        recipes: { id: [], name: []},
        allRecipes: 1,
        users: { id: [], name: []},
        allUsers: 1,
        warehouses: { id: [], name: []},
        allWarehouses: 1,
        contractors: { id: [], name: []},
        allContractors: 1,
    })
    const [isModalOpen, setIsModalOpen] = useState({open: false, key: ""})
    const [defaultScheduler, setDefaultScheduler] = useState({
        RecurringEveryTime: 0,
        RecurringEveryName: "Jednorazowo",
        StartDateTime: min,
        ReportConditionId: null,
        RecipientsIds: [],
        RecipientsEmails: [],
    })
    const [scheduler, setScheduler] = useState({defaultScheduler})
    const recurringEveryList = [
        {RecurringEveryName: "Jednorazowo"     , RecurringEveryTime: 0},
        {RecurringEveryName: "Raz na godzine"  , RecurringEveryTime: 3600},
        {RecurringEveryName: "Raz na 6 godzin" , RecurringEveryTime: 21600},
        {RecurringEveryName: "Raz na 12 godzin", RecurringEveryTime: 43200},
        {RecurringEveryName: "Raz na dobę"     , RecurringEveryTime: 86400},
        {RecurringEveryName: "Raz na tydzień"  , RecurringEveryTime: 604800},
        {RecurringEveryName: "Raz na miesiąc"  , RecurringEveryTime: 2592000},
    ]

    const [activeLabel, setActiveLabel] = useState(null);
    const [isLoading, setIsLoading] = useState("");
    const resetTypedReport = () => {setTypedReport({ name: "", id: "", description: "", timeSpan: "" })};
    const { fetchMssqlApi } = useFetch();
    const resetFilter = () => {setFilter({
            reportName: "",
            isShared: 1,
            timeSpan: 0,
            machines: { id: [], name: []},
            MachinesTags: { id: [], name: [], type: []},
            allMachines: 1,
            products: { id: [], name: []},
            ProductsTags: { id: [], name: [], type: []},
            allProducts: 1,
            recipes: { id: [], name: []},
            allRecipes: 1,
            users: { id: [], name: []},
            allUsers: 1,
            warehouses: { id: [], name: []},
            allWarehouses: 1,
            contractors: { id: [], name: []},
            allContractors: 1,
        })}
    const inputRecipient = useRef();
    const mapIdsToNames = React.useCallback((ids = [], sectionKey) => {
        if (typeof ids === "string") {try {ids = JSON.parse(ids)} catch {return []}}
        const list = inputs[sectionKey] || [];
        return ids.map(id => list.find(i => Number(i.Id) === Number(id))?.Name)
    }, [inputs]);

    const handleEnterAdd = (e, list, fieldKey, section) => {
        if (e.key !== "Enter") return;
        const value = e.target.value?.trim();
        e.target.value = "";
        if (!value) return;
        const item = list.find(p => String(p[fieldKey]) === value);
        if (!item) return;
        if (filter[section].id.includes(item.Id)) return;
        setFilter(prev => ({
            ...prev,
            [section]: {
            id: [...prev[section].id, item.Id],
            name: [...prev[section].name, item.Name]
            }
        }));
    };

    const handleRemove = (section, value) => {
        const index = filter[section].name.indexOf(value);
        if (index === -1) return;
        setFilter(prev => ({
            ...prev,
            [section]: {
            id: prev[section].id.filter((_, i) => i !== index),
            name: prev[section].name.filter((_, i) => i !== index)
            }
        }));
    };
    const handleChangeReport = (field, value) => {
        setTypedReport(prev => ({ ...prev, [field]: value}));
        if (!value) {
            setTypedReport({ name: "", id: "", description: "", timeSpan: ""})
            setSelectedReport({})
        };
        let report = null;
        if (field === "name") {
            report = reportList.find(r => r.reportName === value);
        } else if (field === "id") {
            report = reportList.find(r => String(r.reportId) === value);
        } else if (field === "description") {
            report = reportList.find(r => r.reportDescription === value);
        }
        if (report) {
            setSelectedReport(report);
            setTypedReport(prev => ({
                ...prev,
                name: report.reportName,
                id: String(report.reportId),
                description: report.reportDescription,
                timeSpan: prev.timeSpan
            }));
        } else {
            setSelectedReport({});
        }
    };

    const getUsers = () => {fetchMssqlApi('users-list', {}, response => setUsers(response))}


    const handleChangeTimeSpan = (value) => {
        const timeSpan = selectedReport.timeSpans.find(ts => ts.name === value.trim())
        if (timeSpan) {
            setFilter(prev => ({...prev, timeSpan: timeSpan.id}))
        } else {
            setFilter(prev => ({...prev, timeSpan: 0}))
        }
    }

    const activeSectionsCount = useMemo(() => {
        if (!selectedReport) return 0;
        const sections = ["Products", "Machines", "Recipes", "Users", "Warehouses", "Contractors"];
        const aSectionsCount = sections.filter(key => selectedReport[`include${key}`] === 1).length;
        return (aSectionsCount <= 1 ? 1 : 2)
    }, [selectedReport]);


    const handleSize = () => {
        let modalSize = activeSectionsCount;
        if (step === "select") return "";
        if ([2, 3, 18].includes(filter?.timeSpan)) modalSize++;
        if (step === "config" || step === "edit") {
            if (modalSize <= 1) return "lg";
            if (modalSize >= 2) return "xl";
        }
        if (step === "scheduler") return "md";
        return "lg";
    };
    const handleConfig = (e) => {
        e.preventDefault();
        if (selectedReport?.reportId) {setTimeout(setStep("config"))}
    };

    const handleSave = (e, state) => {
        if ((step === "edit") || step === "config") {
            setIsLoading("Zapisz")
            e.preventDefault();
            let tags = { id: [], type: [] };
            const mapSection = (filter, key) => {
                const includeKey = `include${key}`
                const allKey = `all${key}`;
                const tagKey = `${key}Tags`;
                const baseKey = key.toLowerCase();
                if (selectedReport[includeKey] === 0) return { [`includeAll${key}`]: 0, [baseKey]: [], [tagKey]: [] };
                if (filter[allKey] === 1) return { [`includeAll${key}`]: 1, [baseKey]: [], [tagKey]: [] };
                if (filter[allKey] === 0 && filter[baseKey].id.length === 0) return { [`includeAll${key}`]: 1, [baseKey]: [], [tagKey]: [] };
                if (filter[allKey] === 0) return { [`includeAll${key}`]: 0, [baseKey]: JSON.stringify(filter[baseKey].id) || [], [tagKey]: [] };
                if (filter[allKey] === -1 && filter[tagKey].id.length === 0 ) return { [`includeAll${key}`]: 1, [baseKey]: [] };
                if (filter[allKey] === -1) { const sectionTags = filter[tagKey] || { id: [], type: [] }; tags.id.push(...(sectionTags.id || [])); tags.type.push(...(sectionTags.type || [])); return { [`includeAll${key}`]: 0, [baseKey]: [] };}
                return {};
            };
            let body = {
                reportId: selectedReport?.reportId,
                reportName: filter.reportName.trim(),
                isShared: filter.isShared,
                timeSpanId: filter.timeSpan,
                fromCreateDateTime: range.start,
                toCreateDateTime: range.end,
                ...mapSection(filter, "Machines"),
                ...mapSection(filter, "Products"),
                ...mapSection(filter, "Recipes"),
                ...mapSection(filter, "Users"),
                ...mapSection(filter, "Warehouses"),
                ...mapSection(filter, "Contractors"),
                tags: tags
            }
            if (state === "add") {
                body.reportId = selectedReport?.reportId;
                fetchMssqlApi("reports/addReportCondition", { method: "POST", data: body, hideNotification: true }, () => {
                    setIsLoading("");
                    NotificationManager.success("Raport dodany pomyślnie");
                    onConfirm();
                    onHide()
                });
            }
            if (state === "edit") {
                body.reportConditionId = reportConditionId;
                fetchMssqlApi("reports/updateReportCondition", { method: "POST", data: body, hideNotification: true }, () => {
                    setIsLoading("");
                    NotificationManager.success("Raport zaktaulizowany pomyślnie");
                    onConfirm();
                    onHide();
                });
            }}
        if (step === "scheduler") {
            setIsLoading("Zapisz")
            e.preventDefault();
            if (state === "add") {
                let body = {
                    RecurringEveryTime: scheduler?.RecurringEveryTime, 
                    StartDateTime: scheduler?.StartDateTime, 
                    ReportConditionId: scheduler?.ReportConditionId, 
                    RecipientsIds: JSON.stringify(scheduler?.RecipientsIds), 
                    RecipientsEmails: JSON.stringify(scheduler?.RecipientsEmails)
                };
                fetchMssqlApi("reports/addReportTask", { method: "POST", data: body, hideNotification: true }, () => {
                    setIsLoading("");
                    NotificationManager.success("Harmonogram dodany pomyślnie");
                    onConfirm();
                    onHide()
                });
            }
            if (state === "edit") {
                let body = {
                    RecurringEveryTime: scheduler?.RecurringEveryTime,
                    StartDateTime: scheduler?.StartDateTime, 
                    ReportTaskId: reportTask?.ReportTaskId,
                    RecipientsIds: JSON.stringify(scheduler?.RecipientsIds), 
                    RecipientsEmails: JSON.stringify(scheduler?.RecipientsEmails)
                };
                fetchMssqlApi("reports/updateReportTask", { method: "POST", data: body, hideNotification: true }, () => {
                    setIsLoading("");
                    NotificationManager.success("Harmonogram zaktaulizowany pomyślnie");
                    onConfirm();
                    onHide();
                });
            }
        }
    }

    const handleDelete = () => {
        setIsLoading("Usuń")
        if (step === "edit") {
            fetchMssqlApi("reports/deleteReportCondition", { method: "POST", data: {reportConditionId: reportConditionId}, hideNotification: true }, () => {
            setIsLoading("")
            NotificationManager.success("Raport usunięty pomyślnie");
            onConfirm();
            onHide();
            });
        }
        if (step === "scheduler") {
            fetchMssqlApi("reports/deleteReportTask", { method: "POST", data: {ReportTaskId: reportTask?.ReportTaskId}, hideNotification: true }, () => {
            setIsLoading("")
            NotificationManager.success("Harmonogram usunięty pomyślnie");
            onConfirm();
            onHide();
            });
        }
    }

    const handleBack = () => {
        resetTypedReport();
        setInputs();
        setSelectedReport({});
        resetFilter();
        setStep("select");
    }

    const handleClose = () => {
        onHide();
    };

    const handleAfterClose = () => {
        setStep("select");
        setInputs({});
        resetFilter();
        resetTypedReport();
        setScheduler(defaultScheduler);
        setSelectedReport({});
        setLoadingEdit(null);
        setLoadingScheduler(null);
    };

    const updateRecurring = (value) => {
        const recurringEvery = recurringEveryList.find(x => x.RecurringEveryName.toLowerCase() === value?.toLowerCase());
        if (value === "") setScheduler(prev => ({...prev, RecurringEveryName: "", RecurringEveryTime: 0}));
        if (!recurringEvery) return;
        setScheduler(prev => ({...prev, RecurringEveryName: recurringEvery.RecurringEveryName, RecurringEveryTime: recurringEvery.RecurringEveryTime}));
    };
    
    const addRecipient = (value) => {
        const user = users.find(u => u.Name?.toLowerCase() === value?.toLowerCase())
        if (user) {
            if (!user.Name.match(/\(([^\s@]+@[^\s@]+)\)/)?.[1]) return;
            const email = user.Name.match(/\(([^\s@]+@[^\s@]+)\)/)?.[1];
            const id = user.UserId;
            const includeEmail = scheduler.RecipientsEmails.includes(email);
            if (includeEmail ) return;
            const includeId = scheduler.RecipientsEmails.includes(id);
            if (includeId ) return;
            setScheduler(prev => ({...prev, RecipientsEmails: [...prev.RecipientsEmails, email], RecipientsIds: [...prev.RecipientsIds, id]}))
            inputRecipient.current.value = "";
        }
    }
    
    const removeRecipient = (value) => {
        const includeEmail = scheduler?.RecipientsEmails.includes(value);
        const user = users.find(u => u.Name?.match(/\(([^\s@]+@[^\s@]+)\)/)?.[1].toLowerCase() === value?.toLowerCase())
        if (includeEmail && user) {
            setScheduler(prev => ({...prev, RecipientsEmails: [...prev.RecipientsEmails.filter(u => u !== value)], RecipientsIds: [...prev.RecipientsIds.filter(u => u !== user.UserId)]}))
        }
    };

    const changeStartDateTime = (e) => {
        const value = e.target.value;
        if (moment(value).isBefore(moment(min))) { setScheduler(prev => ({...prev, StartDateTime: min})); return}
        setScheduler(prev => ({...prev, StartDateTime: value}));
    }

    const renderDataLists = useMemo(() => {
        if (!inputs || !Object.keys(inputs).length) return null;
        return Object.entries(inputs).map(([key, arr]) => (
            <datalist id={`${key}List`} key={key}>
            {arr.map((p) => (
                <option key={p.Id} value={p.Name} />
            ))}
            </datalist>
        ));
    }, [inputs]);

    const isSaveDisabled = () => {
        if (step === "scheduler") {
        if (scheduler?.RecurringEveryName === "") return true;
        if (scheduler?.RecurringEveryTime < 0) return true;
        if (scheduler?.RecipientsEmails?.length <= 0) return true;
        if (scheduler?.RecipientsIds?.length <= 0) return true;
        if (scheduler?.StartDateTime === "") return true;
        } else {
        const isValidDate = (d) => d && !isNaN(new Date(d).getTime());
        if (filter?.reportName?.trim().length < 3) return true;
        if (filter?.timeSpan === 0) return true;
        if ([3, 18].includes(filter?.timeSpan)) {if (!isValidDate(range?.start) || !isValidDate(range?.end)) return true}
        if (filter?.timeSpan === 2) {if (!isValidDate(range?.start)) return true}
        }
        return false;
    };

    useEffect(() => {
        if (!selectedReport?.reportId) return;
        if (loadingScheduler) return;
        fetchMssqlApi(
            "reports/reportInputs",
            { method: "POST", data: {
                includeMachines: selectedReport?.includeMachines, 
                includeProducts: selectedReport?.includeProducts, 
                includeRecipes: selectedReport?.includeRecipes, 
                includeUsers: selectedReport?.includeUsers, 
                includeWarehouses: selectedReport?.includeWarehouses, 
                includeContractors: selectedReport?.includeContractors
            }, hideNotification: true, showLoader: false },
            (response) => {
                const parsed = {};
                response.forEach((arr) => {
                    if (!arr.length) return;
                    const section = arr[0].Section;
                    parsed[section] = arr.map(({ Id, Name, Type}) => ({ Id, Name, Type}));
                });
                setInputs(parsed)
            }
        )
    }, [step, selectedReport]);

    useEffect(() => {
        if (step !== "edit") return;
        if (!reportConditionId) return;
        fetchMssqlApi(
            "reports/getReportCondition",
            { method: "POST", data: { reportConditionId }, hideNotification: true},
            (response) => {
                const data = response[0][0];
                const tags = JSON.parse(data?.Tags || "[]");
                const machinesTags = tags.filter(t => t.TagType === 1);
                const allMachines = data?.IncludeAllMachines === 0 ? (machinesTags.length > 0 ? -1 : 0): 1;
                const productsTags = tags.filter(t => t.TagType === 2);
                const allProducts = data?.IncludeAllProducts === 0 ? (productsTags.length > 0 ? -1 : 0): 1;
                setFilter({
                    reportName: data.Name,
                    isShared: data.IsShared,
                    timeSpan: data?.TimeSpanId,
                    machines: {id: JSON.parse(data?.Machines).map(String), name: mapIdsToNames(data?.Machines, "Machines")},
                    MachinesTags: {
                        id: JSON.parse(data.Tags)?.filter(t => t.TagType === 1).map(t => String(t.TagId)), 
                        name: mapIdsToNames(((JSON.parse(data.Tags)?.filter(t => t.TagType === 1).map(t => t.TagId)).map(String)), "MachinesTags"),
                        type: JSON.parse(data.Tags)?.filter(t => t.TagType === 1).map(t => String(t.TagType))},
                    allMachines: allMachines,
                    products: {id:  JSON.parse(data?.Products).map(String), name: mapIdsToNames(data?.Products, "Products")},
                    ProductsTags: {
                        id: JSON.parse(data.Tags)?.filter(t => t.TagType === 2).map(t => String(t.TagId)), 
                        name: mapIdsToNames(((JSON.parse(data.Tags)?.filter(t => t.TagType === 2).map(t => t.TagId)).map(String)), "ProductsTags"), 
                        type: JSON.parse(data.Tags)?.filter(t => t.TagType === 2).map(t => String(t.TagType))},
                    allProducts: allProducts,
                    recipes: {id: JSON.parse(data?.Recipes).map(String), name: mapIdsToNames(data?.Recipes, "Recipes")},
                    allRecipes: data?.IncludeAllRecipes,
                    users: {id: JSON.parse(data?.Users).map(String), name: mapIdsToNames(data?.Users, "Users")},
                    allUsers: data?.IncludeAllUsers,
                    warehouses: {id: JSON.parse(data?.Warehouses).map(String), name: mapIdsToNames(data?.Warehouses, "Warehouses")},
                    allWarehouses: data?.IncludeAllWarehouses,
                    contractors: {id: JSON.parse(data?.Contractors).map(String), name: mapIdsToNames(data?.Contractors, "Contractors")},
                    allContractors: data?.IncludeAllContractors,
                });
                setRange(prev => ({
                    start: data?.StartDateTime ?? prev.start,
                    end:   data?.EndDateTime   ?? prev.end
                }));
                setLoadingEdit(null);
            }
        );
    }, [step, inputs, reportConditionId]);

    function addMonthKeepLastDay(dateInput) {
        const date = new Date(dateInput);
        const y = date.getFullYear(); const m = date.getMonth(); const d = date.getDate();
        const daysInThisMonth = new Date(y, m + 1, 0).getDate();
        const isLastDay = d === daysInThisMonth;
        const nextMonthFirstDay = new Date(y, m + 1, 1);
        const daysInNextMonth = new Date(nextMonthFirstDay.getFullYear(), nextMonthFirstDay.getMonth() + 1, 0 ).getDate();
        const targetDay = isLastDay ? daysInNextMonth : Math.min(d, daysInNextMonth);
        return new Date( nextMonthFirstDay.getFullYear(), nextMonthFirstDay.getMonth(), targetDay, date.getHours(), date.getMinutes(), date.getSeconds());
    }
    function recurring(val, lastStart) {
        if (val !== 2592000 || !lastStart) return val;
        const start = new Date(lastStart);
        const next = addMonthKeepLastDay(start);
        return Math.floor((next - start) / 1000);
    }

    useEffect(() => {
        if (!reportConditionId || !reportId) return;
        if (loadingEdit !== null) {
            resetFilter();
            const report = reportList.find(r => r.reportId === reportId);
            setSelectedReport(report);
            setStep("edit");
        }
        if (loadingScheduler !== null) {
            resetFilter();
            const report = reportList.find(r => r.reportId === reportId);
            getUsers();
            setSelectedReport(report);
            if (reportTask) {
                const StartDateTime = reportTask?.LastEnd ? moment(reportTask?.LastStart).add(recurring(reportTask?.RecurringEvery, reportTask?.LastStart), "seconds").format("YYYY-MM-DD HH:mm") : moment(reportTask?.LastStart).format("YYYY-MM-DD HH:mm");
                setScheduler({
                    RecurringEveryTime: reportTask?.RecurringEvery,
                    RecurringEveryName: recurringEveryList.find(r => r.RecurringEveryTime === reportTask?.RecurringEvery)?.RecurringEveryName,
                    StartDateTime: StartDateTime,
                    ReportConditionId: reportConditionId,
                    RecipientsIds: reportTask?.UserIds,
                    RecipientsEmails: reportTask?.UserEmails,
                })
            } 
            else {
                setScheduler({
                    RecurringEveryTime: 0,
                    RecurringEveryName: "Jednorazowo",
                    StartDateTime: min,
                    ReportConditionId: reportConditionId,
                    RecipientsIds: [],
                    RecipientsEmails: []
                })};
            setStep("scheduler");
        }
    }, [reportConditionId, reportId]);

    useEffect(() => {
        if (step === "edit") {setLoadingEdit(reportConditionId)}
        if (step === "scheduler") {setLoadingScheduler(reportConditionId)}
    }, [step])

    const renderedSections = useMemo(() => {
        if (!inputs || !selectedReport) return null;

        const sections = [
            { key: "Products", label: "Produkty", allLabel: "Wszystkie", selectedLabel: "Wybrane", isTagAble: true },
            { key: "Machines", label: "Automaty", allLabel: "Wszystkie", selectedLabel: "Wybrane", isTagAble: true },
            { key: "Recipes", label: "Receptury", allLabel: "Wszystkie", selectedLabel: "Wybrane", isTagAble: false },
            { key: "Users", label: "Użytkownicy", allLabel: "Wszyscy", selectedLabel: "Wybrani", isTagAble: false },
            { key: "Warehouses", label: "Magazyny", allLabel: "Wszystkie", selectedLabel: "Wybrane", isTagAble: false },
            { key: "Contractors", label: "Kontrahenci", allLabel: "Wszyscy", selectedLabel: "Wybrani", isTagAble: false },
        ];

        return sections.map(({ key, label, allLabel, selectedLabel, isTagAble}) => {
            const section = key.toLowerCase();
            const includeKey = `include${key}`;
            const allKey = `all${key}`;
            const tagKey = `${key}Tags`;
            const list = inputs?.[key];
            const include = selectedReport?.[includeKey] === 1;
            const allValue = filter[allKey];

            if (!include) return null;

            return (
            <div key={key} className={"col-12 col-lg-12 col-xl-6 form-group"}>
                <div className="form-group d-flex justify-content-between align-items-center p-0 m-0">
                <label className="mt-3 mr-2"><h6>{label}</h6></label>
                <ToggleButtonGroup
                    className="toggle-group-sm rounded-pill bg-light overflow-hidden toggle-group border border-color-dark"
                    // style={{width: `${isTagAble ? "17rem" : "12rem"}`}}
                    style={{width: "12rem"}}
                    type="radio"
                    name={allKey}
                    value={allValue}
                    onChange={(val) => setFilter((prev) => ({ ...prev, [allKey]: val }))}
                >
                    <ToggleButton variant="outline-dark" className="btn-sm border-0 p-1 m-1 rounded-pill" value={1} >
                        {allLabel}
                    </ToggleButton>
                    <ToggleButton variant="outline-dark" className="btn-sm border-0 p-1 m-1 rounded-pill" value={0} >
                        {selectedLabel}
                    </ToggleButton>
                    {/* {isTagAble && (
                    <ToggleButton variant="outline-dark" className="btn-sm border-0 p-1 m-1 rounded-pill" value={-1} >
                        Tagi
                    </ToggleButton>
                    )} */}
                </ToggleButtonGroup>
                </div>
                {allValue === 1 && (
                <div>
                    <input className="form-control" placeholder={allLabel} disabled />
                </div>
                )}
                {allValue === 0 && (
                <div>
                    <input
                        className="form-control"
                        key={section}
                        list={`${key}List`}
                        placeholder="Szukaj..."
                        autoComplete="off"
                        onKeyDown={(e) => handleEnterAdd(e, list, "Name", section)}
                    />
                    
                    <ListGroup className="border border-color-dark" style={{ maxHeight: "10rem", overflow: "auto" }}>
                    {filter[section]?.name?.map((p, i) => (
                        <ListGroup.Item key={i} className="py-1 px-1 d-flex justify-content-between align-items-center">
                        <span className="text-truncate" title={p}>{p}</span>
                        <button type="button" className="btn btn-sm btn-outline-danger" onClick={() => handleRemove(section, p)}>
                            <i className="fas fa-times" />
                        </button>
                        </ListGroup.Item>
                    ))}
                    </ListGroup>
                </div>
                )}
                {allValue === -1 && (
                <div className="mb-1 mt-1 text-lg-left">
                    {filter[tagKey]?.name.map((t, i) => (
                    <button key={i} className="btn btn-info badge badge-pill p-1 m-1">
                        {t}
                    </button>
                    ))}
                    <button type="button" className="btn btn-info badge badge-pill px-2 p-1 m-1" onClick={() => {setActiveLabel(null); setIsModalOpen({open: true, key: tagKey})}}>
                        <i className="fas fa-plus"/>                
                    </button>
                </div>
                )}
            </div>
        )});
    }, [inputs, filter, selectedReport]);

    return (
    <div>
        <Modal show={show} onHide={handleClose} onExited={handleAfterClose} centered backdrop="static" size={handleSize()}>
            <Modal.Header closeButton>
                <Modal.Title>     
                {step === "select"    && (<div>Wybór raportu</div>)}
                {step === "config"    && (<div>Konfiguracja raportu DZ{selectedReport.reportId}</div>)}
                {step === "edit"      && (<div>Edycja raportu DZ{selectedReport.reportId}</div>)}
                {step === "scheduler" && (<div>Harmonogram</div>)}
                </Modal.Title>
            </Modal.Header>
            {step === "select" && (
                <Modal.Body>
                    <div className="form-group">
                        <label className="h6">Nazwa raportu</label>
                        <input
                            className="form-control"
                            list="reNameList"
                            placeholder="Szukaj..."
                            value={typedReport.name}
                            onChange={(e) => handleChangeReport("name", e.target.value)}
                        />
                        <datalist id="reNameList">
                            {reportList.map((r) => (
                                <option key={r.reportId} value={r.reportName} />
                            ))}
                        </datalist>
                    </div>
                    <div className="form-group">
                        <label className="h6">Numer raportu</label>
                        <input
                            className="form-control"
                            list="reIdList"
                            placeholder="Szukaj..."
                            value={typedReport.id}
                            onChange={(e) => handleChangeReport("id", e.target.value)}
                        />
                        <datalist id="reIdList">
                            {reportList.map((r) => (
                                <option key={r.reportId} value={r.reportId}/>
                            ))}
                        </datalist>
                    </div>
                    <div className="form-group">
                        <label className="h6">Opis raportu</label>
                        <input
                            className="form-control"
                            list="reDescriptionList"
                            placeholder="Szukaj..."
                            value={typedReport.description}
                            onChange={(e) => handleChangeReport("description", e.target.value)}
                        />
                        <datalist id="reDescriptionList">
                            {reportList.map((r) => (
                                <option key={r.reportId} value={r.reportDescription}/>
                            ))}
                        </datalist>
                    </div>
                </Modal.Body>
            )}
            {(step === "config" || step === "edit") && (
                <Modal.Body>
                    <div className="row">
                        <div className={[2, 3, 18].includes(filter?.timeSpan) ? "col-12 col-lg-6 col-xl-8" : "col-12"}>
                            <div className="row">
                                <div className="col-12 col-lg-12 col-xl-6 form-group">
                                    <div className="form-group d-flex justify-content-between align-items-center p-0 m-0">
                                        <label className="mt-3 mr-2"><h6>Nazwa raportu:</h6></label>
                                        <ToggleButtonGroup className="toggle-group-sm rounded-pill bg-light overflow-hidden toggle-group border border-color-secondary" type="radio" name={"isShared"} value={filter.isShared} onChange={(val) => setFilter((prev) => ({ ...prev, isShared: val }))}>
                                                <ToggleButton variant="outline-secondary" className="btn-sm border-0 p-1 pr-2 pl-2 m-1 rounded-pill" value={1}>Publiczny</ToggleButton>
                                                <ToggleButton variant="outline-secondary" className="btn-sm border-0 p-1 pr-2 pl-2 m-1 rounded-pill" value={0}>Prywatny</ToggleButton>
                                        </ToggleButtonGroup>
                                    </div>
                                    <input className={`form-control ${!filter?.reportName ? 'invalid-input' : ''}`} placeholder="Wpisz..." minLength={1} maxLength={100} value={filter.reportName || ""} onChange={(e) => { const value = e.target.value; setFilter((prev) => ({ ...prev, reportName: value}))}}/>
                                </div>
                                <div className="col-12 col-lg-12 col-xl-6 form-group">
                                    <label className="mt-3 mr-2"><h6>Zakres czasowy</h6></label>
                                    <input
                                        className={`form-control`}
                                        list="reTimeSpanList"
                                        placeholder="Szukaj..."
                                        defaultValue={selectedReport?.timeSpans?.find(ts => ts.id === filter.timeSpan)?.name}
                                        disabled={ !selectedReport?.timeSpans?.some(ts => ts?.id && ts?.name) }
                                        onChange={(e) => handleChangeTimeSpan(e.target.value)}
                                    />
                                    <datalist id="reTimeSpanList">
                                        {selectedReport?.timeSpans?.map((ts) => (
                                            <option key={ts.id} value={ts.name}/>
                                        ))}
                                    </datalist>
                                </div>
                                {renderedSections}
                                {renderDataLists}
                            </div>
                        </div>
                        {([2, 3, 18].includes(filter?.timeSpan)) && (
                        <div className="col-12 col-lg-6 col-xl-4">
                            <div className="row-md-8">
                                <div>
                                    <DateRangePicker range={range} setRange={setRange} timeSpan={filter?.timeSpan}/>
                                </div>
                            </div>
                        </div>
                        )}
                    </div>
                </Modal.Body>)
            }
            {step === "scheduler" && (
            <Modal.Body className="py-0 pb-3">
                <div className="form-group m-0">
                    <div className="form-group d-flex justify-content-between align-items-center p-0 m-0">
                        <label className="mt-3 mr-2"><h6>Nazwa raportu:</h6></label>
                    </div>
                    <input className={`form-control`} defaultValue={reportConditionName} disabled title={reportConditionName}/>
                </div>
                <div className="form-group m-0">
                    <div className="form-group d-flex justify-content-between align-items-center p-0 m-0">
                        <label className="mt-3 mr-2"><h6>Częstotliwość:</h6></label>
                    </div>
                    <div className="d-flex flex-row">
                        <select className={`form-control p-1`} value={scheduler?.RecurringEveryName} onChange={(e) => updateRecurring(e.target.value)}>
                        {recurringEveryList.map(r => (
                            <option key={r.RecurringEveryTime}>{r.RecurringEveryName}</option>
                        ))}
                        </select>
                    </div>
                </div>
                <div className="form-group m-0">
                    <div className="form-group d-flex justify-content-between align-items-center p-0 m-0">
                        <label className="mt-3 mr-2"><h6>Wysyłaj do:</h6></label>
                    </div>
                        <input className="form-control" ref={inputRecipient} list={`recipientsList`} placeholder="Szukaj..." autoComplete="on" onChange={(e) => {addRecipient(e.target.value)}}/>
                    <datalist id="recipientsList">
                    {users.filter(user => !scheduler?.RecipientsIds?.includes(user.UserId))?.map((u) => (
                        <option key={u.UserId}>{u.Name}</option>
                    ))}
                    </datalist>
                    <ListGroup className="border border-color-dark" style={{ maxHeight: "10rem", overflow: "auto" }}>
                    {scheduler.RecipientsEmails?.map((u, i) => (
                    <ListGroup.Item key={i} className="py-1 px-1 d-flex justify-content-between align-items-center">
                        <span className="text-truncate" title={u}>{u}</span>
                        <button type="button" className="btn btn-sm btn-outline-danger" onClick={() => removeRecipient(u)}>
                            <i className="fas fa-times" />
                        </button>
                    </ListGroup.Item>
                    ))}
                    </ListGroup>
                </div>
                <div className="form-group m-0">
                    <div className="form-group d-flex justify-content-between align-items-center p-0 m-0">
                        <label className="mt-3 mr-2"><h6>{!reportTask ? ((scheduler?.RecurringEveryTime === 0) ? "Uruchomienie:" : "Pierwsze uruchomienie:") : (reportTask?.RecurringEvery === 0) ? "Uruchomienie:" : "Kolejne uruchomienie:"}</h6></label>
                    </div>
                    <div className="form-group d-flex">
                        <input type="datetime-local" min={min} max={"9999-12-30T23:59"} value={scheduler?.StartDateTime} onChange={changeStartDateTime} className="form-control"></input>
                        {scheduler?.StartDateTime !== "" && (<i className="d-flex fas fa-times btn btn-outline-danger col-1 justify-content-center align-items-center rounded-0" onClick={(e) => {const input = e.target.previousSibling; input.value = ""; setScheduler(prev => ({...prev, StartDateTime: ""}))}}/>)}
                    </div>
                </div>
            </Modal.Body>)}
        <Modal.Footer className="justify-content-between">
            {step === "select" && (
            <>
                <Button variant="secondary" onClick={handleClose}>Anuluj</Button>
                <Button variant="primary" onClick={handleConfig} disabled={(!selectedReport?.reportId)}>Konfiguracja</Button>
            </>)}
            {step === "config" && (
            <>
                <Button variant="secondary" onClick={handleBack}>Wstecz</Button>
                <Button variant="primary" onClick={(e) => handleSave(e, "add")} disabled={isSaveDisabled()} className={`ml-2 ${isLoading !== "" ? "pe-none" : ""}`} style={{minWidth: "80px"}}>{isLoading === "Zapisz" ? (<i className="fas fa-circle-notch fa-spin"/>) : (<div>Zapisz</div>)}</Button>
            </>
            )} 
            {step === "edit" && (
                <>
                <Button variant="secondary" onClick={handleClose}>Anuluj</Button>
                <div>
                    <Button variant="danger"  onClick={handleDelete} className={`ml-2 ${isLoading !== "" ? "pe-none" : ""}`} style={{minWidth: "70px"}}>{isLoading === "Usuń" ? (<i className="fas fa-circle-notch fa-spin"/>) : (<div>Usuń</div>)}</Button>
                    <Button variant="primary" onClick={(e) => handleSave(e, "edit")} disabled={isSaveDisabled()} className={`ml-2 ${isLoading !== "" ? "pe-none" : ""}`} style={{minWidth: "80px"}}>{isLoading === "Zapisz" ? (<i className="fas fa-circle-notch fa-spin"/>) : (<div>Zapisz</div>)}</Button>
                </div>
            </>
            )}
            {step === "scheduler" && (
                <>
                <Button variant="secondary" onClick={handleClose} className="mr-2">Anuluj</Button>
                <div>
                    {reportTask && (<Button variant="danger"  onClick={handleDelete} className={`ml-2 ${isLoading !== "" ? "pe-none" : ""}`} style={{minWidth: "70px"}}>{isLoading === "Usuń" ? (<i className="fas fa-circle-notch fa-spin"/>) : (<div>Usuń</div>)}</Button>)}
                    <Button variant="primary" onClick={(e) => handleSave(e, !reportTask ? "add" : "edit")} disabled={isSaveDisabled()} className={`ml-2 ${isLoading !== "" ? "pe-none" : ""}`} style={{minWidth: "80px"}}>{isLoading === "Zapisz" ? (<i className="fas fa-circle-notch fa-spin"/>) : (<div>{reportTask ? "Zapisz" : "Dodaj"}</div>)}</Button>
                </div>
            </>
            )}
        </Modal.Footer>
        </Modal>
        {isModalOpen.open && (
            <Modal show={true} onHide={() => setIsModalOpen({open: false})} centered >
                <Modal.Header closeButton>
                    <h6 className="m-0">Tagi</h6>
                </Modal.Header>
                <Modal.Body className="p-0">
                    {(() => {
                        const data = inputs[isModalOpen?.key] || [];
                        const grouped = data.reduce((acc, t) => {
                            let [labelPart, namePart] = t.Name.split(" - ");
                            if (!namePart) {labelPart = "Inne"; namePart = t.Name.trim();}
                            if (!acc[labelPart]) acc[labelPart] = [];
                            acc[labelPart].push({ id: t.Id, name: namePart});
                            return acc;
                        }, {});
                        let labelKeys = Object.keys(grouped);
                        const handleLabelClick = (label) => () => {
                            setActiveLabel((prev) => (prev === label ? null : label));
                        };
                        let handleTagClick = (tagId) => () => {
                            const tag = inputs[isModalOpen.key].find(t => t.Id === tagId);
                            if (!tag) return;
                            setFilter((prev) => {
                                const section = prev[isModalOpen.key] || { id: [], name: [], type: [] };
                                const alreadySelected = section.id.includes(tag.Id);
                                return {
                                ...prev,
                                [isModalOpen.key]: {
                                    id: alreadySelected ? section.id.filter((x) => x !== tag.Id) : [...section.id, tag.Id],
                                    name: alreadySelected ? section.name.filter((_, i) => section.id[i] !== tag.Id) : [...section.name, tag.Name],
                                    type: alreadySelected ? section.type.filter((_, i) => section.id[i] !== tag.Id) : [...section.type, tag.Type],
                                },
                                };
                            });
                        };
                        let isSelected = (id) =>
                            filter[isModalOpen?.key]?.id?.includes(id);
                       return (
                        <div className="row m-0 p-0">
                            <div className="col col-md-6 overflow-auto m-0 p-0" style={{ maxHeight: 250}}>
                            {labelKeys.map((label, idx) => (
                                <div key={idx}
                                    className={`list-group-item font-weight-bolder cursor-pointer ${activeLabel === label ? "active" : ""}`}
                                    onClick={handleLabelClick(label)}>
                                {label}
                                </div>
                            ))}
                            </div>
                            {activeLabel && (
                            <div className="col col-md-6 overflow-auto m-0 p-0" style={{ maxHeight: 250 }}>
                                {grouped[activeLabel].map((opt) => (
                                <div key={opt.id} 
                                    className={`list-group-item font-weight-bolder cursor-pointer ${isSelected(opt.id) ? "list-group-item-success" : ""}`}
                                    onClick={handleTagClick(opt.id)}>
                                    {opt.name}
                                </div>
                                ))}
                            </div>
                            )}
                        </div>
                        );
                    })()}
                </Modal.Body>
            </Modal>
        )}
    </div>
    );
}
